import { Controller } from "@hotwired/stimulus"

// Groups the notification carousel items so each Bootstrap slide shows up to 4 cards.
export default class extends Controller {
  connect() {
    const items = this.element.querySelectorAll(".carousel-item")
    const minPerSlide = 4

    items.forEach((el) => {
      let next = el.nextElementSibling
      for (let i = 1; i < minPerSlide; i++) {
        if (!next) {
          // wrap the carousel by reusing the first item
          next = items[0]
        }
        const cloneChild = next.cloneNode(true)
        el.appendChild(cloneChild.children[0])
        next = next.nextElementSibling
      }
    })
  }
}
